mutation UpdateContactName($input: ContactUpdateInput!) {
    contactUpdate(input: $input) {
        contact {
            id
        }
    }
}
